module.exports = __webpack_public_path__ + "static/projectsHeader-412061835c8d8642b777b416d9295d73.jpg";